"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DamageCaseCancellationReason = exports.DamageStatus = exports.DamageFault = exports.DamageType = exports.DamageReportedAt = void 0;
var DamageReportedAt;
(function (DamageReportedAt) {
    DamageReportedAt["RECEIVING"] = "RECEIVING";
    DamageReportedAt["PICKING"] = "PICKING";
})(DamageReportedAt = exports.DamageReportedAt || (exports.DamageReportedAt = {}));
var DamageType;
(function (DamageType) {
    DamageType["DAMAGED"] = "DAMAGED";
    DamageType["EXPIRED"] = "EXPIRED";
})(DamageType = exports.DamageType || (exports.DamageType = {}));
var DamageFault;
(function (DamageFault) {
    DamageFault["DELIVERR"] = "DELIVERR";
    DamageFault["SELLER"] = "SELLER";
    DamageFault["UNKNOWN"] = "UNKNOWN";
})(DamageFault = exports.DamageFault || (exports.DamageFault = {}));
var DamageStatus;
(function (DamageStatus) {
    DamageStatus["CREATED"] = "CREATED";
    DamageStatus["PENDING"] = "PENDING";
    DamageStatus["COMPLETED"] = "COMPLETED";
    DamageStatus["CANCELLED"] = "CANCELLED";
})(DamageStatus = exports.DamageStatus || (exports.DamageStatus = {}));
var DamageCaseCancellationReason;
(function (DamageCaseCancellationReason) {
    DamageCaseCancellationReason["ACCIDENTALLY_MOVED_TO_DAMAGES"] = "ACCIDENTALLY_MOVED_TO_DAMAGES";
    DamageCaseCancellationReason["DEEMED_SELLABLE"] = "DEEMED_SELLABLE";
    DamageCaseCancellationReason["OTHER"] = "OTHER";
})(DamageCaseCancellationReason = exports.DamageCaseCancellationReason || (exports.DamageCaseCancellationReason = {}));
//# sourceMappingURL=DamagedProductUnified.js.map